import { useState } from "react";
import DownloadIcon from "@mui/icons-material/Download";
import { Alert, Button, Snackbar } from "@mui/material";

import * as Sentry from "@sentry/react";
import { useShowNetworkFailureToast } from "../../NetworkFailureToast";
import { useTrueBizApi } from "../../../api";
import { useIdentity } from "../../IdentityProvider";

export default function ExportSearchHistoryButton() {
  const [working, setWorking] = useState(false);
  const [successToastOpen, setSuccessToastOpen] = useState(false);
  const showErrorToast = useShowNetworkFailureToast();
  const api = useTrueBizApi();

  const { isImpersonating } = useIdentity();

  const createExport = async () => {
    setWorking(true);
    try {
      await api.initiateMonitoringAnomaliesExport({
        emailOnSuccess: !isImpersonating, // don't send email if impersonating
      });
      setSuccessToastOpen(true);
    } catch (e) {
      Sentry.captureException(e);
      showErrorToast("Data export failed, please try again shortly.");
    } finally {
      setWorking(false);
    }
  };

  return (
    <>
      <Button
        id="basic-button"
        onClick={createExport}
        variant="outlined"
        disabled={working}
      >
        <DownloadIcon sx={{ ml: -0.5, mr: 1 }} /> Export
      </Button>

      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={successToastOpen}
        autoHideDuration={8000}
        onClose={() => setSuccessToastOpen(false)}
      >
        <Alert severity="success" variant="filled" sx={{ width: "100%" }}>
          Export initiated. You will receive an email with a link to download
          the file once it is ready.
        </Alert>
      </Snackbar>
    </>
  );
}
